var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeepInfra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M7.5 9.2h6.9c4.03 0 7.3 3.27 7.3 7.3s-3.27 7.3-7.3 7.3H7.5V9.2Zm3.05 2.83v8.94h3.7a4.47 4.47 0 0 0 0-8.94h-3.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M23.35 9.2h3.15v14.6h-3.15V9.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepInfra);
export default __webpack_public_path__ + "static/media/DeepInfra.bfa26bcef4089159905751fbe0e78716.svg";
export { ForwardRef as ReactComponent };